module.exports = __webpack_public_path__ + "img/paypal.6f83a487.svg";